// 4 điểm đến nhóm đã thực địa (nội dung từ Script.docx) + 4 chủ đề bổ sung: ghe xuồng, đan đát Sóc Trăng, đờn ca tài tử Bạc Liêu, đám giỗ miền Tây.
// image: để trống thì thẻ hiển thị ô màu + biểu tượng; thêm ảnh thật bằng cách gán đường dẫn, ví dụ image: '/tan-chau.jpg' (đặt file trong /public).
export const stories = [
  {
    "slug": "lang-to-lua-tan-chau",
    "title": "Ghé Tân Châu: Nghe tiếng thoi dệt & chuyện Lãnh Mỹ A bên dòng sông Tiền",
    "place": "Thị xã Tân Châu, An Giang",
    "excerpt": "Về Tân Châu ghé thăm xưởng dệt gia đình bên dòng sông Tiền, nghe tiếng thoi lạch cạch và \"un-lock\" bí thuật nhuộm trái mặc nưa tạo nên Lãnh Mỹ A - loại lụa tự nhiên trứ danh với khả năng thích ứng thời tiết linh hoạt cùng vẻ đẹp sang trọng vượt thời gian.!",
    "body": [
      {
        "type": "p",
        "text": "Về An Giang, tụi mình tìm đến tận một hộ dân làm nghề dệt lụa lâu đời nằm êm đềm bên dòng sông Tiền ở thị xã Tân Châu. Vừa bước qua khoảng sân phơi nắng rực rỡ ngập tràn những sào lụa đen tuyền bóng mượt, tiếng khung dệt lạch cạch... lạch cạch... đã vang vọng khắp gian nhà."
      },
      {
        "type": "h",
        "text": "1. Ký ức về một \"xứ tằm tang\" hoàng kim"
      },
      {
        "type": "p",
        "text": "Ngồi bên tách trà ấm cùng chú chủ xưởng dệt lâu năm, chú kể rằng nghề trồng dâu nuôi tằm ở Tân Châu bắt đầu phát triển rực rỡ từ đầu thế kỷ XX nhờ dải đất phù sa ven sông Tiền vô cùng màu mỡ."
      },
      {
        "type": "ul",
        "items": [
          [
            "Giai đoạn 1920 - 1945",
            "Tân Châu nhanh chóng trở thành thủ phủ tơ lụa sầm uất và nổi tiếng nhất vùng Nam Bộ."
          ],
          [
            "Vươn xa quốc tế",
            "Sản phẩm lụa Tân Châu khi ấy không chỉ phục vụ cho giới thượng lưu, quý tộc Nam Kỳ mà còn theo các thương lái xuất khẩu sang Campuchia, Lào, Thái Lan, Philippines và thậm chí vươn xa sang thị trường Châu Âu."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Bí thuật tạo nên tuyệt tác Lãnh Mỹ A"
      },
      {
        "type": "p",
        "text": "Sở dĩ Lãnh Mỹ A được mệnh danh là \"nữ hoàng của các loại tơ tằm\" là nhờ quy trình chế tác hoàn toàn thủ công vô cùng kỳ công mà không máy móc hiện đại nào thay thế được:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Kỹ thuật dệt Satin 8",
            "Tơ tằm tự nhiên được chọn lọc kỹ càng và dệt theo kỹ thuật Satin 8 (kỹ thuật dệt satin khó nhất) để tạo độ dai, mịn và bề mặt óng ả."
          ],
          [
            "Nhuộm nhựa trái mặc nưa",
            "Bí quyết cốt lõi nằm ở quả mặc nưa. Nhựa trái mặc nưa khi giã nát có màu xanh mộc mạc, nhưng khi ngấm sâu vào sợi tơ và tiếp xúc với nắng gió sông Tiền sẽ tự oxy hóa chuyển thành màu đen tuyền bóng bẩy."
          ],
          [
            "100 lần nhuộm - phơi kiên trì",
            "Tấm lụa phải trải qua hơn 100 lần giặt, đập, nhuộm nhựa và phơi nắng liên tục trong gần 4 tháng ròng."
          ],
          [
            "Đặc tính độc bản",
            "Lãnh Mỹ A có khả năng \"mát rượi vào mùa hè, ấm áp vào mùa đông\". Đặc biệt, lụa không phai màu mà càng giặt lại càng mềm mại, óng ả theo thời gian."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Ngọn lửa giữ nghề trong gian nhà nhỏ"
      },
      {
        "type": "p",
        "text": "Thập niên 1970, sự xuất hiện của sợi tổng hợp và vải nylon giá rẻ tràn ngập thị trường khiến làng nghề suy giảm mạnh. Tuy nhiên, nhờ tâm huyết của những nghệ nhân kỳ cựu (như gia đình cố nghệ nhân Tám Lăng), ngọn lửa dệt lụa truyền thống vẫn được kiên trì giữ qua bao thăng trầm."
      },
      {
        "type": "p",
        "text": "Ngày nay, ghé thăm nhà dân Tân Châu, bạn sẽ nhận ra bước chuyển mình đầy sức sống của thế hệ tiếp nối:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Mở rộng bảng màu thiên nhiên",
            "Ngoài màu đen mặc nưa truyền thống, người thợ đã nghiên cứu nhuộm thêm nhiều màu sắc tự nhiên từ vỏ cây, củ quả (đỏ bóc-đô, vàng đồng, xám, hồng cánh sen...)."
          ],
          [
            "Vươn tầm thời trang quốc tế",
            "Lãnh Mỹ A trở thành chất liệu cao cấp đồng hành cùng các NTK tên tuổi Việt Nam (như Võ Việt Chung, Công Trí) xuất hiện kiêu hãnh trên các sàn diễn lớn như New York Fashion Week và tạp chí Vogue."
          ],
          [
            "Du lịch trải nghiệm",
            "Các xưởng dệt gia đình mở cửa đón du khách ghé thăm, tận mắt chứng kiến quy trình ươm tơ, dệt vải và tự tay thử nhuộm lụa bằng trái mặc nưa."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Chạm tay vào tấm Lãnh Mỹ A mát rượi ngay tại xưởng dệt gia đình, mới thấy trân trọng từng giọt mồ hôi và tài hoa của người thợ Tân Châu. Đây không chỉ là một sản phẩm may mặc, mà là cả một di sản văn hóa sống động vẫn đang chảy tràn sức sống bên dòng sông Tiền."
      }
    ],
    "refs": [
      [
        "Báo Lao Động",
        "Lãnh Mỹ A - tơ lụa quý tộc một thời",
        "laodong.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Lụa Lãnh Mỹ A - Hồn đất An Giang",
        "vov.vn"
      ],
      [
        "Ủy ban Nhà nước về người Việt Nam ở nước ngoài (SCOV - Bộ Ngoại giao)",
        "Thăm làng dệt lụa Tân Châu - An Giang",
        "scov.gov.vn"
      ],
      [
        "Cổng thông tin Điện tử tỉnh An Giang",
        "Làng nghề dệt tơ lụa Tân Châu",
        "angiang.gov.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Gìn giữ di sản lụa Tân Châu An Giang",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "3 phút đọc",
    "province": "An Giang",
    "icon": "checkroom",
    "date": "28/09/2026",
    "short": "Lụa Lãnh Mỹ A",
    "category": "Câu chuyện",
    "image": "/ToLua.png",
    "featured": true,
    "order": 1
  },
  {
    "slug": "tho-cam-cham-chau-phong",
    "title": "Ghé Châu Phong: Tiếng thoi dệt thổ cẩm trong ngôi nhà sàn người Chăm",
    "place": "Xã Châu Phong, Thị xã Tân Châu, An Giang",
    "excerpt": "Băng qua sông Hậu ghé thăm nhà sàn người Chăm ở Châu Phong, nghe tiếng thoi dệt lạch cạch và khám phá bí thuật nhuộm màu tự nhiên tạo nên những tấm thổ cẩm rực rỡ nét đẹp di sản Nam Bộ!",
    "body": [
      {
        "type": "p",
        "text": "Băng qua lòng sông Hậu rộng lớn, tụi mình tìm về xã Châu Phong (thị xã Tân Châu, An Giang) và dừng chân trước một ngôi nhà sàn gỗ cổ kính của gia đình cô Chăm. Trong không gian yên bình rợp bóng mát, tiếng dập khung dệt lạch cạch... lạch cạch... ngân vang rộn rã từng nhịp nhịp nhàng."
      },
      {
        "type": "h",
        "text": "1. Nét đẹp văn hóa lâu đời của cộng đồng Chăm"
      },
      {
        "type": "p",
        "text": "Bên khung dệt gỗ cổ truyền, cô Chăm mỉm cười chào khách rồi tỉ tê kể về nguồn gốc nghề dệt thổ cẩm của đồng bào mình bên dòng sông Hậu:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Gắn liền với đời sống",
            "Nghề dệt thổ cẩm hình thành cùng quá trình định cư của người Chăm An Giang, truyền từ mẹ sang con qua biết bao thế hệ phụ nữ trong gia đình."
          ],
          [
            "Biểu tượng trang phục",
            "Từng chiếc xà rông, khăn mêu (khăn đội đầu), áo thổ cẩm dệt ra không chỉ để mặc hằng ngày mà còn là trang phục trang trọng không thể thiếu trong các dịp lễ hội lớn như lễ Ramadan, lễ Raya..."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Kỹ thuật dệt thủ công với hoa văn tinh xảo"
      },
      {
        "type": "p",
        "text": "Mỗi sản phẩm thổ cẩm Châu Phong là một tác phẩm nghệ thuật đòi hỏi sự kiên nhẫn, đôi mắt thẩm mỹ và sự khéo léo tối đa của người thợ:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Nhuộm màu tự nhiên",
            "Sợi chỉ được nhuộm từ nguyên liệu thiên nhiên như vỏ cây, mủ cây, củ mặc nưa... tạo ra các gam màu sống động, bền đẹp như đỏ bóc-đô, vàng nghệ, xanh lá, xám đen."
          ],
          [
            "Kỹ thuật dệt thủ công tỉ mỉ",
            "Người thợ dùng đôi chân nhịp nhàng đạp bàn dập, đôi tay uyển chuyển đưa thoi luồn từng sợi chỉ màu qua lại."
          ],
          [
            "Hoa văn độc đáo",
            "Các họa tiết hình học, ô vuông, đường zigzag, bông hoa... được tính toán chính xác trực tiếp trong đầu và thể hiện nhịp nhàng trên khung dệt mà không cần bất kỳ bản vẽ sẵn nào."
          ],
          [
            "Sản phẩm phong phú",
            "Bên cạnh xà rông, khăn mêu truyền thống, làng nghề còn dệt nên túi xách, bóp viền, nón, khăn quàng cổ phục vụ đời sống hiện đại."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Lan tỏa sức sống thổ cẩm Châu Phong"
      },
      {
        "type": "p",
        "text": "Ngày nay, làng dệt thổ cẩm Châu Phong không chỉ giữ gìn truyền thống mà còn trở thành điểm sáng du lịch văn hóa thu hút du khách trong và ngoài nước:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Mô hình Hợp tác xã",
            "Các hộ dân liên kết sản xuất, chuẩn hóa chất lượng để đưa sản phẩm thổ cẩm Châu Phong đến với các thị trường du lịch lớn."
          ],
          [
            "Trải nghiệm văn hóa bản địa",
            "Du khách ghé thăm được bước lên nhà sàn gỗ, tìm hiểu phong tục tập quán, khoác thử trang phục truyền thống Chăm và tự tay thử đưa thoi dệt vải trên khung gỗ."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Ghé thăm ngôi nhà sàn Châu Phong, ngắm nhìn những tấm thổ cẩm rực rỡ sắc màu dưới ánh nắng chiều sông Hậu, tụi mình cảm nhận sâu sắc bản sắc văn hóa độc đáo và tình yêu di sản tha thiết của đồng bào Chăm An Giang."
      }
    ],
    "refs": [
      [
        "Cổng thông tin Điện tử tỉnh An Giang",
        "Độc đáo nghề dệt thổ cẩm Chăm Châu Phong",
        "angiang.gov.vn"
      ],
      [
        "Báo Dân tộc và Phát triển (Uỷ ban Dân tộc)",
        "Giữ lửa nghề dệt thổ cẩm Chăm ở Châu Phong",
        "baodantoc.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Thổ cẩm Châu Phong - Sức hút nét văn hóa Chăm An Giang",
        "vov.vn"
      ],
      [
        "Báo Lao Động",
        "Sức sống làng dệt thổ cẩm Chăm Châu Phong",
        "laodong.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Khám phá làng dệt thổ cẩm Chăm Châu Phong, An Giang",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "2 phút đọc",
    "province": "An Giang",
    "icon": "texture",
    "date": null,
    "short": "Thổ cẩm Chăm",
    "category": "Câu chuyện",
    "image": "/DetThoCam.png",
    "order": 2
  },
  {
    "slug": "lo-gach-mang-thit",
    "title": "Ghé Mang Thít: Ngơ ngác trước \"vương quốc lò gạch\" bên dòng Cổ Chiên",
    "place": "Huyện Mang Thít, Tỉnh Vĩnh Long",
    "excerpt": "Xuôi dòng Cổ Chiên ghé xưởng gạch ven kênh Thầy Đức, ngắm hàng trăm lò vòm đỏ thắm mọc lên như tháp cổ và cảm nhận sức sống của \"Vương quốc gốm đỏ\" Mang Thít!",
    "body": [
      {
        "type": "p",
        "text": "Theo dòng sông Cổ Chiên xuôi về huyện Mang Thít (Vĩnh Long), tụi mình ghé vào xưởng làm gạch lâu đời của gia đình chú Bảy nằm ven kênh Thầy Đức. Từ xa nhìn lại, hàng trăm lò gạch gốm hình vòm đỏ thắm mọc lên san sát nhau trông như những ngọn tháp cổ kính tuyệt đẹp nổi bật trên nền trời miền Tây."
      },
      {
        "type": "h",
        "text": "1. Ký ức về di sản công nghiệp sông nước"
      },
      {
        "type": "p",
        "text": "Rót chén trà xanh mời khách, chú Bảy hồi tưởng lại thời kỳ hoàng kim của vùng đất được mệnh danh là \"Vương quốc lò gạch\":"
      },
      {
        "type": "ul",
        "items": [
          [
            "Lịch sử hàng trăm năm",
            "Nghề làm gạch gốm Mang Thít hình thành và phát triển từ đầu thế kỷ XX nhờ dải đất sét đỏ phù sa ven sông Cổ Chiên dồi dào, màu mỡ."
          ],
          [
            "Thời kỳ rực rỡ",
            "Những năm 1980 - 1990, nơi đây có đến hàng ngàn lò gạch hoạt động rực lửa ngày đêm. Gạch gốm theo tàu thủy xuôi dòng ra biển lớn xuất khẩu đi khắp châu Âu, châu Mỹ và các nước Đông Nam Á."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Kỳ công nhào nặn đất phù sa thành gốm đỏ"
      },
      {
        "type": "p",
        "text": "Để tạo nên những viên gạch, sản phẩm gốm đỏ độc đáo trứ danh Mang Thít, người thợ phải trải qua những công đoạn vất vả, công phu:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Khai thác & nhồi đất",
            "Đất sét đỏ phù sa được lọc kỹ, nhồi thật dẻo mịn trước khi đưa vào khuôn tạo hình."
          ],
          [
            "Chất lò & đốt lửa",
            "Gạch sống sau khi phơi khô được xếp cẩn thận vào bên trong lò hình vòm. Người thợ dùng trấu đốt lửa liên tục suốt nhiều ngày đêm để nung chín."
          ],
          [
            "Sắc đỏ tự nhiên",
            "Nhờ đặc tính của đất sét sông Cổ Chiên và kỹ thuật canh lửa tài hoa, gạch gốm ra lò có màu đỏ cam tự nhiên, lên nước bóng mịn mà không cần qua bất kỳ khâu nhuộm màu nào."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Bước chuyển mình thành Di sản tương lai"
      },
      {
        "type": "p",
        "text": "Dù nhịp sản xuất công nghiệp hiện đại khiến nhiều lò gạch nung trấu truyền thống ngưng hoạt động, Mang Thít đang đứng trước bước ngoặt di sản đầy tự hào:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Đề án \"Di sản tương lai Mang Thít\"",
            "Tỉnh Vĩnh Long quy hoạch bảo tồn vùng lò gạch cổ thành không gian di sản công nghiệp và kiến trúc độc đáo bậc nhất ĐBSCL."
          ],
          [
            "Điểm check-in & nghệ thuật",
            "Những lò gạch hình vòm rêu phong trở thành nguồn cảm hứng nghệ thuật, thu hút đông đảo du khách và nhiếp ảnh gia tìm đến thưởng lãm, ghi lại những thước phim đắt giá."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Bước chân giữa những vòm lò gạch rêu phong nhuốm màu thời gian, chạm tay vào chất gốm đỏ ấm áp, mới cảm nhận trọn vẹn sức sống kiên cường và nét đẹp độc bản của di sản Mang Thít bên dòng Cổ Chiên."
      }
    ],
    "refs": [
      [
        "Báo Điện tử Chính phủ",
        "Bảo tồn di sản đương đại Mang Thít Vĩnh Long",
        "baochinhphu.vn"
      ],
      [
        "Cổng thông tin Điện tử tỉnh Vĩnh Long",
        "Làng nghề gạch gốm Mang Thít",
        "vinhlong.gov.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Vương quốc lò gạch Mang Thít - Di sản độc đáo Nam Bộ",
        "vov.vn"
      ],
      [
        "Báo Lao Động",
        "Hồn gốm đỏ Mang Thít bên dòng Cổ Chiên",
        "laodong.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Khám phá Vương quốc gốm đỏ Mang Thít, Vĩnh Long",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "2 phút đọc",
    "province": "Vĩnh Long",
    "icon": "account_balance",
    "date": "01/10/2026",
    "short": "Gốm đỏ Mang Thít",
    "category": "Câu chuyện",
    "image": "/Gach.png",
    "order": 3
  },
  {
    "slug": "banh-trang-cu-lao-may",
    "title": "Ghé Cù lao Mây: Dạo bếp tráng bánh & thưởng thức vị ngọt hơn bách niên",
    "place": "Cù lao Mây (Xã Phú Thành, Huyện Trà Ôn, Tỉnh Vĩnh Long)",
    "excerpt": "Qua chuyến phà ngang ghé thăm căn bếp nhỏ cù lao Mây, xem các cô các chị thoăn thoắt tráng từng chiếc bánh dẻo thơm và \"thưởng thức\" hương vị ngọt ngào hơn 100 năm tuổi!",
    "body": [
      {
        "type": "p",
        "text": "Về Vĩnh Long, tụi mình đón chuyến phà ngang bồng bềnh sang đất cù lao Mây (xã Phú Thành, huyện Trà Ôn). Vừa rẽ vào con hẻm nhỏ rợp bóng cây xanh bưởi mận, mùi thơm lừng của nếp chín quyện với nước cốt dừa béo ngậy từ căn bếp nhà các cô, các chị đã nhanh chóng níu chân tụi mình lại."
      },
      {
        "type": "h",
        "text": "1. Ký ức về làng nghề tráng bánh trăm năm"
      },
      {
        "type": "p",
        "text": "Bên bếp lửa bập bùng ấm áp, cô chủ nhà vừa đổ bột lên khuôn vải tráng vừa cười kể, nghề làm bánh tráng ở cù lao Mây đã gắn liền với bao thế hệ nơi đây suốt hơn một thế kỷ qua:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Nguồn gốc lâu đời",
            "Ban đầu xuất phát từ thói quen tự tráng bánh để thưởng thức và đãi khách mỗi dịp Lễ, Tết hay cúng giỗ của cư dân dải cù lao ven sông Hậu."
          ],
          [
            "Giao thương rộn rã",
            "Nhờ chất lượng thơm ngon vượt trội, bánh tráng cù lao Mây theo ghe bầu xuôi dòng sông Hậu tỏa đi khắp các tỉnh miền Tây và theo chân người con xa xứ đi khắp nơi."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Bí quyết tạo nên từng chiếc bánh dẻo thơm"
      },
      {
        "type": "p",
        "text": "Để có được tấm bánh tráng mỏng dẻo, thơm lừng đặc trưng, người dân cù lao phải tỉ mỉ chăm chút từng công đoạn hoàn toàn thủ công:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Chọn gạo & xay bột",
            "Phải chọn loại gạo nếp ngon, ngâm đủ giờ rồi xay nhuyễn, pha thêm nước cốt dừa béo ngậy và chút gia vị nêm nếm vừa vặn."
          ],
          [
            "Kỹ thuật tráng bánh",
            "Bàn tay người thợ thoăn thoắt xoay gáo bột đều tắp trên nồi hơi ngút khói, tráng bánh mỏng như giấy mà không hề bị rách."
          ],
          [
            "Phơi nắng vạt dừa",
            "Bánh tráng xong được nhấc cẩn thận lên chiếc vạt (vỉ) dừa đem phơi nắng tự nhiên. Nắng cù lao vừa đủ làm bánh khô lại nhưng vẫn giữ trọn độ dẻo dai."
          ],
          [
            "Đa dạng hương vị",
            "Ngoài bánh tráng nem truyền thống, làng nghề còn biến tấu thêm bánh tráng ngọt, bánh tráng nướng, bánh tráng ớt, bánh tráng sữa... đậm đà khẩu vị Nam Bộ."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Giữ lửa làng nghề nơi đất cù lao"
      },
      {
        "type": "p",
        "text": "Dù hiện nay máy móc công nghiệp rất phổ biến, nhiều hộ dân cù lao Mây vẫn kiên trì giữ phương pháp làm thủ công để bảo tồn nguyên vẹn hương vị truyền thống:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Hợp tác xã làng nghề",
            "Nhiều hộ gia đình đã liên kết lại thành Làng nghề Bánh tráng Cù lao Mây để hỗ trợ nhau đảm bảo chất lượng và đầu ra ổn định."
          ],
          [
            "Trải nghiệm du lịch",
            "Khách ghé thăm được tự tay thử tráng bánh trên nồi hơi, học cách nhấc bánh lên vạt dừa và thưởng thức chiếc bánh nướng nóng hổi ngay tại bếp."
          ]
        ]
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Thưởng thức một miếng bánh tráng dẻo thơm ngay tại căn bếp nhỏ cù lao Mây, mới cảm nhận trọn vẹn sự ngọt ngào của dải đất phù sa và tấm lòng hào sảng, hiếu khách của người dân Vĩnh Long."
      }
    ],
    "refs": [
      [
        "Báo Điện tử Chính phủ",
        "Làng nghề bánh tráng Cù lao Mây Vĩnh Long",
        "baochinhphu.vn"
      ],
      [
        "Cổng thông tin Điện tử tỉnh Vĩnh Long",
        "Làng nghề truyền thống Bánh tráng Cù Lao Mây",
        "vinhlong.gov.vn"
      ],
      [
        "Báo Lao Động",
        "Đậm đà hương vị bánh tráng Cù lao Mây",
        "laodong.vn"
      ],
      [
        "Đài Phát thanh và Truyền hình Vĩnh Long (THVL)",
        "Độc đáo bánh tráng Cù lao Mây",
        "thvl.vn"
      ],
      [
        "Cục Du lịch Quốc gia Việt Nam",
        "Khám phá du lịch làng nghề Bánh tráng Cù lao Mây",
        "vietnamtourism.gov.vn"
      ]
    ],
    "read": "2 phút đọc",
    "province": "Vĩnh Long",
    "icon": "bakery_dining",
    "date": null,
    "short": "Bánh tráng Cù lao Mây",
    "category": "Câu chuyện",
    "image": "/BanhTrang.png",
    "order": 4
  },
  {
    "slug": "ghe-tau-song-nuoc-mien-tay",
    "title": "Ghe tàu sông nước miền Tây: Những “đôi chân” trên kênh rạch Cửu Long",
    "place": "Sông nước Đồng bằng sông Cửu Long (Cần Thơ, An Giang…)",
    "excerpt": "Từ chiếc xuồng ba lá ghép từ ba tấm ván đến ghe máy đuôi tôm và những chiếc ghe hàng trăm tấn, mỗi loại ghe xuồng đều kết tinh kinh nghiệm sống chung với sông nước của người miền Tây — và vẫn lặng lẽ chở nếp sống ấy đi tiếp đến hôm nay!",
    "body": [
      {
        "type": "p",
        "text": "Ở miền Tây, sông rạch chằng chịt như mạng nhện nên từ lâu ghe xuồng đã trở thành “đôi chân” của người dân. Nhà vườn ven sông gần như nhà nào cũng có đôi ba chiếc xuồng, ghe lớn nhỏ, chèo tay hoặc gắn máy nổ, tùy việc mà đem ra dùng. Tụi mình tìm hiểu để thấy mỗi loại ghe xuồng đang mang một câu chuyện riêng như thế nào."
      },
      {
        "type": "h",
        "text": "1. Xuồng và ghe — khác nhau ở đâu?"
      },
      {
        "type": "p",
        "text": "Dân gian thường gọi gộp là “ghe xuồng”, nhưng hai loại phương tiện này khác nhau khá rõ:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Xuồng",
            "Nhỏ gọn hơn, dài khoảng 4 mét, thường ghép từ vài tấm ván lớn, hợp để đi gần nhà và len vào kênh rạch nhỏ. Các loại quen thuộc gồm xuồng ba lá, xuồng năm lá, xuồng tam bản, xuồng vỏ gòn, xuồng độc mộc và xuồng máy."
          ],
          [
            "Ghe",
            "Lớn hơn, có boong chiếm hơn nửa chiều dài, có bánh lái và cần điều khiển, thường dùng chở hàng và đi xa. Tên gọi cũng rất đa dạng: ghe bầu, ghe lồng, ghe chài, ghe cào tôm, ghe hầu, ghe ngo…"
          ],
          [
            "Chuyện cái tên “tam bản”",
            "Từ này bắt nguồn từ tiếng Hoa “xam pản”, người Pháp phiên âm thành “sampan” rồi lan ra khắp vùng sông nước Nam Bộ."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Xuồng ba lá — chiếc xuồng bé nhỏ của đất Nam Bộ"
      },
      {
        "type": "p",
        "text": "Gọi là “ba lá” vì nguyên bản thân xuồng được đóng từ ba tấm ván: một tấm bản lớn làm đáy, hai tấm còn lại làm mạn xuồng. Xuồng ba lá trung bình dài khoảng 4 mét, rộng 1 mét, chở được 4 – 6 người; các đường nối được trét nhựa chai, mũi và lái đều nhọn để dễ luồn qua những con rạch hẹp."
      },
      {
        "type": "ul",
        "items": [
          [
            "Nhiều cách chèo",
            "Người ta có thể chèo mái đứng, chèo bằng hai chân hoặc chèo một mái; đoạn cạn thì dùng sào nạng để đẩy xuồng đi."
          ],
          [
            "Như “đôi chân” của mỗi nhà",
            "Nhà nào ở miền Tây phía trước cũng có một chiếc xuồng ba lá, đi gần đi xa đều trông cậy vào nó."
          ],
          [
            "Mỗi vùng một kiểu",
            "Riêng vùng Cần Thơ, loại xuồng ra đời sớm là xuồng năm lá (ghép bằng năm tấm ván) cùng ghe tam bản, dễ di chuyển ở những khúc sông lục bình dày đặc."
          ],
          [
            "Biểu tượng với du khách",
            "Nhiều du khách chụp ảnh xuồng ba lá rồi ví von nó như chiếc gondola của xứ Venice phiên bản Nam Bộ."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Từ mái chèo đến ghe máy đuôi tôm, chợ nổi và ghe ngo"
      },
      {
        "type": "ul",
        "items": [
          [
            "Ghe máy đuôi tôm",
            "Xuất hiện từ khoảng thập niên 1960, còn gọi là “tắc ráng”, gắn máy nổ và chân vịt để đi nhanh hơn sức người chèo."
          ],
          [
            "Ghe xuồng của chợ nổi",
            "Ở chợ nổi, người ta lấy mặt sông làm mặt chợ và lấy ghe xuồng làm phương tiện chở hàng hóa, nên hình ảnh ghe bán hàng bập bềnh trên sông gắn liền với đời sống buôn bán miền Tây."
          ],
          [
            "Ghe ngo của người Khmer",
            "Với đồng bào Khmer Nam Bộ, ghe ngo không chỉ để đua tài trên sông nước mà còn được xem là báu vật linh thiêng, được nhiều dòng họ giữ nghề đóng qua nhiều đời."
          ]
        ]
      },
      {
        "type": "h",
        "text": "4. Mỹ Hiệp — nơi nhịp búa đóng ghe vẫn vang bên sông Tiền"
      },
      {
        "type": "p",
        "text": "Làng nghề đóng ghe xuồng Mỹ Hiệp nằm trên Cù lao Giêng giữa sông Tiền (An Giang), được giới thiệu là có tuổi đời hơn 100 năm. Theo các bậc cao niên, nghề đóng xuồng ở đây đã xuất hiện từ thời khẩn hoang."
      },
      {
        "type": "ul",
        "items": [
          [
            "Đủ loại ghe xuồng",
            "Làng nghề đóng xuồng ba lá, xuồng cui, xuồng Ông Chưởng, vỏ lãi cho đến những chiếc ghe có trọng tải hàng trăm tấn."
          ],
          [
            "Vì sao xuồng Mỹ Hiệp được ưa chuộng",
            "Xuồng nhẹ, bền, kín lườn, mũi thon gọn, bơi vững và tiết kiệm sức chèo, giá thành lại hợp lý."
          ],
          [
            "Thăng trầm theo thời cuộc",
            "Những năm 1960 – 1970 là thời kỳ hưng thịnh; sau đó có giai đoạn nhiều trại xuồng chỉ hoạt động cầm chừng vài tháng trong năm."
          ],
          [
            "Mở cửa đón khách",
            "Du khách ghé làng có thể xem tận mắt các công đoạn đóng xuồng và nghe câu chuyện hơn một thế kỷ giữ nghề."
          ]
        ]
      },
      {
        "type": "h",
        "text": "5. Ghe xuồng hôm nay"
      },
      {
        "type": "p",
        "text": "Nhịp sống thay đổi, đường bộ ngày càng nhiều, nhưng vì “trời sinh đất này lắm sông nhiều rạch”, chiếc xuồng con, ghe nhỏ vẫn còn thân thuộc ở miệt vườn. Bên cạnh việc chở người, chở nông sản, nhiều chiếc xuồng ba lá nay còn đưa du khách dạo vườn, ghé rừng tràm hay len vào những con rạch rợp bóng dừa nước."
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Mỗi chiếc ghe, chiếc xuồng không chỉ là một phương tiện đi lại mà còn là kinh nghiệm sống chung với con nước của bao thế hệ người miền Tây. Giữ được tiếng chèo khua nước và nhịp búa đóng ghe bên sông cũng là giữ lại một phần hồn của vùng đất này."
      }
    ],
    "refs": [
      [
        "Báo Sài Gòn Giải Phóng",
        "Xuồng thuyền miền Tây",
        "sggp.org.vn"
      ],
      [
        "Báo Pháp Luật TP.HCM",
        "Dọc ngang miền sông nước",
        "plo.vn"
      ],
      [
        "Đài Tiếng nói Việt Nam (VOV)",
        "Hồn ghe ngo và hành trình giữ lửa của dòng họ 4 đời ở miền Tây",
        "vov.vn"
      ],
      [
        "Báo Thanh Niên",
        "Sông Mê Kông và văn hóa miền sông nước Cửu Long",
        "thanhnien.vn"
      ],
      [
        "Sun Paradise Land (chỉ dẫn du lịch)",
        "Làng nghề đóng ghe xuồng Mỹ Hiệp – Di sản trăm năm giữa An Giang",
        "sunparadiseland.com"
      ],
      [
        "Loigiaihay.com",
        "Soạn bài Ghe xuồng Nam Bộ (SGK Ngữ văn 7, Cánh diều)",
        "loigiaihay.com"
      ]
    ],
    "read": "4 phút đọc",
    "province": "Miền Tây",
    "icon": "directions_boat",
    "date": "03/10/2026",
    "short": "Ghe xuồng sông nước",
    "category": "Câu chuyện",
    "image": "/Ghe5.png",
    "order": 5
  },
  {
    "slug": "lang-nghe-dan-dat-phuoc-quoi-soc-trang",
    "title": "Ghé Phước Quới: Nghe tiếng nan tre trong làng nghề đan đát của người Khmer Sóc Trăng",
    "place": "Ấp Phước Quới, xã Phú Tân, huyện Châu Thành (Sóc Trăng cũ, nay thuộc TP. Cần Thơ)",
    "excerpt": "Về làng nghề đan đát Phước Quới – Phú Tân, nơi bà con Khmer chuốt từng sợi nan tre thành lợp, lờ, rổ, thúng, nia… và nghe chuyện một làng nghề trăm năm đang tìm lối đi mới giữa nhịp sống hiện đại!",
    "body": [
      {
        "type": "p",
        "text": "Nhắc đến Sóc Trăng, nhiều người nghĩ ngay đến bánh pía hay những ngôi chùa Khmer, nhưng vùng đất này còn lưu giữ những làng nghề mà người dân truyền từ đời này sang đời khác. Một trong số đó là làng nghề đan đát ở ấp Phước Quới, xã Phú Tân (huyện Châu Thành), nơi người Khmer biến những cây tre, trúc thành đủ loại vật dụng cho đời sống và sản xuất."
      },
      {
        "type": "h",
        "text": "1. Làng nghề của bà con Khmer"
      },
      {
        "type": "ul",
        "items": [
          [
            "Một nét văn hóa riêng",
            "Nghề đan lát ở Phước Quới từ lâu không chỉ là ngành nghề truyền thống mà đã trở thành một nét văn hóa riêng của đồng bào Khmer."
          ],
          [
            "Từ vài chục hộ đến vài trăm hộ",
            "Ban đầu chỉ có vài chục hộ theo nghề, về sau số hộ tăng lên vài trăm, đa số là người Khmer."
          ],
          [
            "Được đầu tư để giữ nghề",
            "Địa phương dùng nguồn vốn hỗ trợ để xây nhà xưởng, phòng trưng bày sản phẩm và trang bị máy chẻ nan tre; từ năm 2006, hợp tác xã làng nghề được mở rộng với 126 hộ người Khmer tham gia (theo MIA.vn)."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Từ cây tre đến chiếc lợp, chiếc nia"
      },
      {
        "type": "p",
        "text": "Làng nghề đan đát Phú Tân có lịch sử lâu đời, nhiều hộ gia đình sống nhờ các sản phẩm quen thuộc của đời sống sông nước và nhà nông:"
      },
      {
        "type": "ul",
        "items": [
          [
            "Lợp, lờ, rổ xúc tôm cá",
            "Những dụng cụ đánh bắt gắn với vùng đồng ruộng, kênh rạch của người dân Sóc Trăng."
          ],
          [
            "Thúng, nia, xịa, cần xé",
            "Những vật dụng thân thuộc trong gian bếp, ngoài ruộng, ngoài sông; mỗi món cần sự khéo léo và tỉ mỉ của người thợ."
          ],
          [
            "Nan tre, đôi tay và máy hỗ trợ",
            "Tre, trúc được chẻ thành nan rồi đan hoàn toàn bằng tay; riêng khâu chẻ nan nay đã có máy hỗ trợ để người thợ bớt vất vả."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Những con người giữ nghề"
      },
      {
        "type": "p",
        "text": "Theo Báo Văn hóa, bà Lâm Thị Nết ở ấp Phước Quới theo nghề đan đát gần 40 năm, thuộc lòng từng công đoạn; mỗi ngày bà đan được khoảng 4 cần xé và sau khi trừ chi phí thu về gần 100.000 đồng."
      },
      {
        "type": "p",
        "text": "Hợp tác xã Làng nghề đan đát Phú Tân hiện có khoảng 30 thành viên làm đan đát, sản xuất cốm dẹp và hàng thủ công mỹ nghệ. Hợp tác xã liên kết với các cơ sở thu mua, thương lái lớn để lo đầu ra, đồng thời hợp tác với các điểm du lịch để giới thiệu mẫu đan làm quà lưu niệm."
      },
      {
        "type": "h",
        "text": "4. Làm mới nghề xưa"
      },
      {
        "type": "ul",
        "items": [
          [
            "Chị Trương Thị Bạch Thủy",
            "Giám đốc Hợp tác xã Mây tre đan Thủy Tuyết, người Khmer, được công nhận Nghệ nhân cấp Quốc gia ngành mây tre đan vì đã góp phần làm sống lại làng nghề Phú Tân."
          ],
          [
            "Việc làm cho phụ nữ",
            "Theo số liệu báo chí cuối năm 2024, hợp tác xã tạo việc làm ổn định cho 32 xã viên và hơn 60 hội viên phụ nữ; thu nhập trung bình mỗi hộ từ nghề đan đát khoảng 7 – 10 triệu đồng mỗi tháng."
          ],
          [
            "Đưa tre vào không gian sống",
            "Ngoài đồ thủ công mỹ nghệ, hợp tác xã còn đưa tre trúc vào trang trí nội thất, công trình nhà tre, homestay và resort."
          ],
          [
            "Hướng đến du lịch",
            "Làng nghề Phước Quới xây dựng kế hoạch phát triển các sản phẩm mỹ nghệ để phục vụ du khách đến tham quan và mua quà lưu niệm."
          ]
        ]
      },
      {
        "type": "h",
        "text": "5. Nỗi lo giữ nghề"
      },
      {
        "type": "p",
        "text": "Không phải lúc nào làng nghề cũng thuận lợi. Đồ gia dụng công nghiệp ngày càng phổ biến khiến nghề đan đát dần bị mai một; ở nhiều làng nghề truyền thống miền Tây, nghệ nhân ngày một lớn tuổi còn thợ trẻ theo nghề chưa nhiều. Vì vậy đào tạo lớp kế thừa, nâng cao chất lượng và tìm đầu ra ổn định cho sản phẩm là những bài toán được nhắc đến nhiều nhất."
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Cầm trên tay chiếc rổ, chiếc nia đan tay mộc mạc mới thấy hết sự kiên nhẫn của người thợ Khmer Phước Quới. Mỗi sợi nan là một mối nối giữa quá khứ và hiện tại — và việc giữ cho những đôi tay ấy còn đan được là cách để văn hóa làng nghề không lặng đi."
      }
    ],
    "refs": [
      [
        "Báo Văn hóa",
        "Làng nghề đan đát Phú Tân: Câu chuyện sinh kế và phát triển cộng đồng",
        "baovanhoa.vn"
      ],
      [
        "Tạp chí Công Thương",
        "Khởi sắc nghề đan lát Phước Quới",
        "tapchicongthuong.vn"
      ],
      [
        "Báo Nhân Dân",
        "Khát vọng gìn giữ nghề đan tre trúc của người phụ nữ Khmer ở Cần Thơ",
        "nhandan.vn"
      ],
      [
        "MIA.vn",
        "4 làng nghề truyền thống ở Sóc Trăng làm nên tên tuổi của vùng đất này",
        "mia.vn"
      ],
      [
        "Báo Nhân Dân",
        "Hướng phát triển làng nghề truyền thống ở Tây Nam Bộ",
        "nhandan.vn"
      ]
    ],
    "read": "4 phút đọc",
    "province": "Sóc Trăng",
    "icon": "shopping_basket",
    "date": "05/10/2026",
    "short": "Đan đát Phước Quới",
    "category": "Câu chuyện",
    "image": "/dan1.png",
    "order": 6
  },
  {
    "slug": "don-ca-tai-tu-bac-lieu",
    "title": "Ghé Bạc Liêu: Nghe đờn ca tài tử nơi bản “Dạ cổ hoài lang” cất tiếng",
    "place": "Thành phố Bạc Liêu (Bạc Liêu cũ, nay thuộc tỉnh Cà Mau)",
    "excerpt": "Về Bạc Liêu – một trong những cái nôi của đờn ca tài tử Nam Bộ – lắng nghe câu chuyện bản “Dạ cổ hoài lang” ra đời năm 1919, thăm khu lưu niệm nhạc sĩ Cao Văn Lầu và tìm hiểu vì sao tiếng đờn, tiếng ca mộc mạc ấy được UNESCO ghi danh!",
    "body": [
      {
        "type": "p",
        "text": "Nhắc đến Bạc Liêu, nhiều người nhớ đến “công tử Bạc Liêu”, nhưng với người mê cải lương thì đây còn là quê hương của bản “Dạ cổ hoài lang” — bài bản được các nhà nghiên cứu xem là tiền thân của vọng cổ. Tụi mình tìm hiểu vì sao tiếng đờn tiếng ca ở vùng đất này lại được gìn giữ và tự hào đến vậy."
      },
      {
        "type": "h",
        "text": "1. Đờn ca tài tử là gì?"
      },
      {
        "type": "p",
        "text": "Đờn ca tài tử là loại hình nghệ thuật dân gian của Nam Bộ, gắn với những người chơi nhạc vì đam mê — các “tài tử” — vừa đờn vừa ca trong sinh hoạt thường ngày và những buổi giao lưu. Dàn nhạc thường có đờn kìm (đàn nguyệt), đờn tranh, đờn cò, guitar phím lõm…"
      },
      {
        "type": "ul",
        "items": [
          [
            "Di sản nhân loại",
            "Cuối năm 2013, Nghệ thuật Đờn ca tài tử Nam Bộ được UNESCO ghi danh là Di sản văn hóa phi vật thể đại diện của nhân loại."
          ],
          [
            "Phong trào rộng khắp",
            "Theo hồ sơ đệ trình UNESCO, có gần 30.000 người chơi đờn ca tài tử, sinh hoạt trong vài nghìn câu lạc bộ, nhóm, đội."
          ],
          [
            "Bạc Liêu — một cái nôi",
            "Bạc Liêu được xem là một trong những cái nôi của đờn ca tài tử; ở vùng Bạc Liêu cũ, người dân hầu như ai cũng có thể ca đờn ca tài tử và cải lương rất mùi mẫn."
          ]
        ]
      },
      {
        "type": "h",
        "text": "2. Cao Văn Lầu và bản “Dạ cổ hoài lang”"
      },
      {
        "type": "ul",
        "items": [
          [
            "Người sáng tác",
            "Nhạc sĩ Cao Văn Lầu sinh ngày 22/12/1890 ở Long An, năm 9 tuổi theo gia đình đến Bạc Liêu lập nghiệp và mất ngày 13/8/1976."
          ],
          [
            "Ra đời năm 1919",
            "Bản “Dạ cổ hoài lang” (Nghe tiếng trống đêm nhớ chồng) ra đời năm 1919, chất chứa nỗi nhớ thương và cảnh chia xa của vợ chồng."
          ],
          [
            "Từ nhịp 2 đến vọng cổ",
            "Bài bản ban đầu có nhịp 2, về sau phát triển thành vọng cổ nhịp 4, 8, 16, 32, 64; các nhà nghiên cứu xem đây là tiền thân của bài vọng cổ ngày nay."
          ],
          [
            "Nhiều dị bản",
            "Bản nhạc được chỉnh sửa qua nhiều lần nên có nhiều dị bản; Bạc Liêu từng tổ chức hội thảo để xác định văn bản chuẩn."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Dấu ấn giữa lòng phố thị Bạc Liêu"
      },
      {
        "type": "ul",
        "items": [
          [
            "Khu lưu niệm",
            "Khu lưu niệm nghệ thuật đờn ca tài tử Nam Bộ và nhạc sĩ Cao Văn Lầu có bốn ngôi mộ: cha mẹ nhạc sĩ và vợ chồng ông – bà Trần Thị Tấn."
          ],
          [
            "Nhà hát Cao Văn Lầu",
            "Hoàn thành năm 2014, thiết kế theo hình ba chiếc nón lá đan xen, rộng 1.800 m², gồm 3 tầng với độ cao giảm dần — gắn với hình ảnh người phụ nữ Nam Bộ."
          ],
          [
            "Lễ hội Dạ cổ hoài lang",
            "Với các hoạt động như lễ giỗ Tổ cổ nhạc, dâng hương viếng mộ nhạc sĩ, hội thi tìm hiểu Dạ cổ hoài lang – vọng cổ – đờn ca tài tử, hò chèo ghe, nói thơ Bạc Liêu và Liên hoan đờn ca tài tử ba tỉnh Bạc Liêu – Sóc Trăng – Cà Mau."
          ],
          [
            "Mốc 100 năm",
            "Năm 2019, Tuần Văn hóa – Du lịch Bạc Liêu được tổ chức gắn với kỷ niệm 100 năm ra đời bản Dạ cổ hoài lang."
          ]
        ]
      },
      {
        "type": "h",
        "text": "4. Giữ tiếng đờn cho thế hệ sau"
      },
      {
        "type": "p",
        "text": "Nhiều năm qua, các cấp, ngành ở Bạc Liêu mở các lớp hướng dẫn, truyền dạy hát “Dạ cổ hoài lang” và điệu thức trong đờn ca tài tử cho người học, đồng thời gắn di sản với du lịch để khách đến Bạc Liêu có thể vừa tham quan vừa thưởng thức tiếng đờn tại chỗ."
      },
      {
        "type": "p",
        "text": "Lưu ý khi tìm hiểu: từ ngày 1/7/2025, tỉnh Bạc Liêu đã hợp nhất với tỉnh Cà Mau thành tỉnh Cà Mau, nên “Bạc Liêu” hiện nay chủ yếu là tên gọi lịch sử và tên phường, nhưng vị thế “quê hương Dạ cổ hoài lang” của vùng đất này vẫn không thay đổi."
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Một tiếng đờn kìm, một câu ca mùi mẫn cất lên giữa đêm Bạc Liêu cho thấy đờn ca tài tử không phải thứ để ngắm trong bảo tàng mà là nghệ thuật vẫn đang được hát lên mỗi ngày. Giữ được tiếng đờn ấy cũng là giữ lại tiếng lòng mộc mạc, nghĩa tình của người Nam Bộ."
      }
    ],
    "refs": [
      [
        "Báo Văn hóa",
        "Một thế kỷ say đắm bản tình ca bất hủ Dạ cổ hoài lang",
        "baovanhoa.vn"
      ],
      [
        "Báo Nhân Dân",
        "Về quê hương “Dạ cổ hoài lang”",
        "nhandan.vn"
      ],
      [
        "Báo Sài Gòn Giải Phóng",
        "Phát huy giá trị du lịch cho đờn ca tài tử",
        "sggp.org.vn"
      ],
      [
        "Báo Pháp Luật Việt Nam",
        "Bế mạc Lễ hội Dạ cổ Hoài lang Bạc Liêu: Lắng đọng nhiều cảm xúc sâu sắc",
        "baophapluat.vn"
      ],
      [
        "Báo Đầu tư",
        "Rong ruổi phương Nam: Nét duyên của mảnh đất Dạ cổ hoài lang",
        "baodautu.vn"
      ],
      [
        "Báo Nhân Dân",
        "Đờn ca tài tử tiếp tục tỏa sáng",
        "nhandan.vn"
      ]
    ],
    "read": "4 phút đọc",
    "province": "Bạc Liêu",
    "icon": "music_note",
    "date": "10/10/2026",
    "short": "Đờn ca tài tử Bạc Liêu",
    "category": "Câu chuyện",
    "image": "/don2.png",
    "order": 7
  },
  {
    "slug": "dam-gio-mien-tay",
    "title": "Đám giỗ miền Tây: Khi cả xóm cùng thắp nén nhang nhớ người đã khuất",
    "place": "Vùng nông thôn Đồng bằng sông Cửu Long",
    "excerpt": "Hàng xóm sang phụ trước cả khi được mời, nồi thịt kho trứng to đùng, phần quà mang về cho khách… Đám giỗ miền Tây không chỉ là lễ cúng tổ tiên mà còn là bữa cơm đậm đà của tình làng nghĩa xóm!",
    "body": [
      {
        "type": "p",
        "text": "Ở miền Tây, đám giỗ là dịp con cháu từ xa tìm về thắp hương cho người đã khuất, đồng thời gia chủ đón bà con, hàng xóm đến dùng bữa. Tụi mình tìm hiểu để thấy vì sao đám giỗ nơi đây luôn rộn ràng và ấm áp đến vậy."
      },
      {
        "type": "h",
        "text": "1. Lời mời “cập rập” mà không ai trách"
      },
      {
        "type": "p",
        "text": "Điều thú vị là gia chủ lo cúng kiếng rất kỹ nhưng cách mời khách lại khá “cập rập”: có khi tới tối hôm trước ngày chính đám, gia chủ mới lật đật sang từng nhà mời. Vậy mà chẳng ai trách móc; thậm chí hàng xóm tự sắp xếp công việc để sang phụ giúp trước cả khi nhận lời mời."
      },
      {
        "type": "p",
        "text": "Nếp ứng xử này bắt nguồn từ tình làng nghĩa xóm “tối lửa tắt đèn có nhau”. Nhà ai có hậu sự thì bà con lối xóm tới lui chia buồn đến tận lúc chôn cất, nên ngày giỗ sau này cũng khó mà quên."
      },
      {
        "type": "h",
        "text": "2. Một ngày trước — bếp núc rộn ràng"
      },
      {
        "type": "ul",
        "items": [
          [
            "Bà con tề tựu",
            "Trước ngày giỗ một ngày, cô bác anh em gần xa kéo về phụ giúp, người lớn thường dẫn theo con cháu để các em biết gốc gác, nguồn cội."
          ],
          [
            "Cánh đàn ông “ra thịt”",
            "Mổ heo, làm gà, làm vịt xong thì quây quần bên bàn trà hỏi thăm chuyện làm ăn, mùa màng và ôn lại kỷ niệm."
          ],
          [
            "Cánh phụ nữ lo bếp",
            "Sơ chế nguyên liệu cho các món như hủ tiếu xào, heo quay bánh hỏi, vịt nấu cà ri, lẩu cù lao; riêng nồi thịt kho trứng và khổ qua hầm nhồi thịt thường nấu thật to để vừa đãi khách vừa làm quà."
          ],
          [
            "Đãi người phụ bếp",
            "Gia chủ dọn sẵn bình trà đường, cà phê sữa cùng dĩa bánh quê như bánh tét, bánh bò, bánh da lợn, bánh ít; vơi thì lại đầy, giống như “niêu cơm Thạch Sanh”."
          ]
        ]
      },
      {
        "type": "h",
        "text": "3. Tiên thường, chánh giỗ, hậu thường"
      },
      {
        "type": "p",
        "text": "Theo cách gọi xưa, đám giỗ có thể kéo dài ba ngày là tiên thường, chánh giỗ và hậu thường — một nếp nay chỉ còn thấy ở các miền quê, nhất là miền Tây Nam Bộ."
      },
      {
        "type": "ul",
        "items": [
          [
            "Tối tiên thường",
            "Không khí ấm cúng với nồi cháo gà, cháo vịt và món cuốn bì: thịt heo khìa cùng bì xắt sợi trộn thính, đậu phộng, rau thơm rồi cuốn bằng bánh tráng, xếp thành hình tháp, cắt khoanh nhỏ và chấm nước mắm chua ngọt."
          ],
          [
            "Sáng chính đám",
            "Mọi người thức dậy từ tờ mờ sáng nấu các món tiệc. Khi gia chủ báo “bắt mâm”, con cháu bưng thức ăn dâng lên bàn thờ rồi cùng thắp nhang khấn nguyện tổ tiên phù hộ những điều lành."
          ],
          [
            "Món theo sở thích người mất",
            "Bên cạnh các món cúng chung, nhiều nhà còn nấu món người quá cố lúc sinh thời ưa thích, như cá lóc nướng trui, cá lòng tong kho tiêu, mắm ba khía trộn hay canh chua cá chốt."
          ]
        ]
      },
      {
        "type": "h",
        "text": "4. Đi giỗ: có đến là có lòng"
      },
      {
        "type": "p",
        "text": "Người miền Tây thường nói đám giỗ nồng hậu trên tinh thần “thương nhau mới đến, mến nhau mới mời” — khách không đi theo kiểu xã giao."
      },
      {
        "type": "ul",
        "items": [
          [
            "Quà của khách",
            "Ngày xưa khách hay xách theo cam sành, vú sữa hay bịch đường để phụ bếp gia chủ; ngày nay quà gọn hơn bằng phong bì để chủ nhà tiện chi tiêu, nhưng tấm lòng thì vẫn vậy."
          ],
          [
            "Phần mang về",
            "Sau mâm cơm, khách ra về đôi khi còn được gửi thêm bánh, xôi, trái cây hoặc một phần thức ăn. Có người nhà còn người già, trẻ nhỏ xin thêm, gia chủ vẫn vui vẻ gói cho, đúng tinh thần “có gì chia nấy”."
          ]
        ]
      },
      {
        "type": "h",
        "text": "5. Giữ nếp giỗ trong nhịp sống mới"
      },
      {
        "type": "p",
        "text": "Nhịp sống hiện đại thay đổi, mỗi vùng miền một phong tục, nhưng việc cúi đầu tưởng nhớ tổ tiên thì không thay đổi vì ai sinh ra cũng có cội có nguồn. Trong gian bếp đám giỗ, người lớn truyền lại cho con cháu từng việc nhỏ: người nấu lẩu, người ướp thịt, người gói bánh ít… để sau này còn người nối nghiệp giữ nếp nhà."
      },
      {
        "type": "h",
        "text": "Lời kết"
      },
      {
        "type": "p",
        "text": "Một đám giỗ miền Tây là nơi nén nhang gặp tiếng cười, nồi thịt kho gặp tình hàng xóm. Ở đó, người ta không chỉ nhớ người đã khuất mà còn học cách sống tử tế, hào phóng với nhau — thứ “gia phong” mộc mạc nhưng bền bỉ của vùng sông nước."
      }
    ],
    "refs": [
      [
        "Báo Thanh Niên",
        "Đám giỗ miền Tây: Sao hàng xóm chưa được mời đã sang phụ?",
        "thanhnien.vn"
      ],
      [
        "Báo Znews (Tri thức - Znews)",
        "Vì sao đi ăn đám giỗ miền Tây, khách được gói phần mang về?",
        "znews.vn"
      ],
      [
        "Báo Znews (Tri thức - Znews)",
        "Vì sao đám giỗ miền Tây thường có thịt kho trứng?",
        "znews.vn"
      ],
      [
        "Báo Sài Gòn Giải Phóng",
        "Đám giỗ quê nhà",
        "sggp.org.vn"
      ],
      [
        "Báo Sài Gòn Giải Phóng",
        "Về ăn đám giỗ",
        "sggp.org.vn"
      ]
    ],
    "read": "4 phút đọc",
    "province": "Miền Tây",
    "icon": "restaurant",
    "date": "30/10/2026",
    "short": "Đám giỗ miền Tây",
    "category": "Câu chuyện",
    "image": "/gio2.png",
    "order": 8
  },
];
export const categories = ['Tất cả', ...new Set(stories.map(s => s.province))];